import React from 'react';
import styled, { withTheme } from 'styled-components';
import SearchBarContainer from '../shared/SearchBarContainer';
import SearchIconFillable from '../../../svgs/SearchIconFillable';
import SearchDropdown from '../shared/SearchDropdown';

const SearchBarRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  border: solid 1px ${p => p.theme.c.border.secondary};
  border-radius: 4px;
`;

const SearchBarDiv = styled.div`
  position: relative;
  max-width: 700px;
  width: 100%;
  margin-left: 24px;
`;

const SearchInput = styled.input`
  ${p => p.theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
  width: 100%;
  height: ${p => p.theme.unitInt(5) - 2}px;
  margin: 0;
  padding: 0;
  border: 0;
  padding-left: ${p => p.theme.unit(2)};
  padding-right: ${p => p.theme.unit(2)};
  text-overflow: ellipsis;
  ::placeholder {
    color: ${p => p.theme.c.text.secondary};
    ${p => p.theme.typographyRebrand.body.md}
  }
  ::-moz-placeholder {
    color: ${p => p.theme.c.text.secondary};
    ${p => p.theme.typographyRebrand.body.md}
  }

  caret-color: ${p => p.theme.c.border.secondary};
`;

const SearchButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${p => p.theme.unit(5)};
  width: ${p => p.theme.unit(6)};
  min-width: ${p => p.theme.unit(6)};
  background-color: transparent;
  cursor: pointer;
  border: 0;
  border-radius: 3px;
`;

class SearchBar extends SearchBarContainer {
  constructor(props) {
    super(props);
    this.state = { lang: '' };
  }

  componentDidMount() {
    window.addEventListener('mousedown', this.hideResults);
    this.setState({
      lang: document.documentElement.lang,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.hideResults);
  }

  render() {
    const {
      placeholder,
      locale,
      theme,
      searchStoreTitle,
      searchCategoriesTitle,
      searchCtaButtonText,
      pageStateModifiers,
      searchIconLabel,
    } = this.props;

    return (
      <SearchBarDiv
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseLeave}
      >
        <form onSubmit={e => this.onSearch(e, locale)}>
          <SearchBarRow>
            <SearchInput
              aria-label={searchIconLabel}
              type="text"
              value={this.state.value}
              onChange={this.handleChange}
              placeholder={placeholder}
              onFocus={this.handleChange}
            />
            <SearchButton type="submit" aria-label={searchIconLabel}>
              <SearchIconFillable fill={theme.c.icon.interactive} title={searchIconLabel} />
            </SearchButton>
          </SearchBarRow>
        </form>
        <SearchDropdown
          locale={locale}
          shops={this.state.shops}
          categories={this.state.categories}
          searchStoreTitle={searchStoreTitle}
          searchCategoriesTitle={searchCategoriesTitle}
          searchCtaButtonText={searchCtaButtonText}
          pageStateModifiers={pageStateModifiers}
        />
      </SearchBarDiv>
    );
  }
}

export default withTheme(SearchBar);
